import { TableCell, TableHead, TableRow, Typography } from "@mui/material";

export default function ContactsTableHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableCell>
          <Typography className="text-base font-semibold">Name</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography className="text-base font-semibold">Type</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography className="text-base font-semibold">Company</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography className="text-base font-semibold">Phone Number</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography className="text-base font-semibold">Email</Typography>
        </TableCell>
        <TableCell align="left"></TableCell>
      </TableRow>
    </TableHead>
  );
}
